export interface FAQ {
  content: string;
  id: number;
  title: string;
}

export class HomepageRate {
  amount: number;
  currency: string;

  constructor(data: any) {
    this.amount = data.amount;
    this.currency = data.currency_type;
  }
}

export class HomepageInfo {
  faqs: FAQ[];
  rates: HomepageRate[];

  constructor(data: any) {
    this.faqs = data.faq;
    this.rates = data.rate.map((el: any) => new HomepageRate(el));
  }
}

export interface IVForm {
  validate(): boolean;
  reset(): void;
}

export enum EServices {
  http = "http",
  store = "store",
  auth = "auth",
  router = "router",
  general = "general",
  profile = "profile",
  rates = "rates",
  transactions = "transactions",
  banks = "banks",
  notifications = "notifications",
  complaint = "complaint",
  dashboard = "dashboard",
  currencies = "currencies",
  wallets = "wallets",
  security = "security",
  crypto = "crypto",
  account = "account",
  announcement = "announcement",
  referrals = "referrals",
  ranks = "ranks",
  biometric = "biometric",
  kyc = "kyc",
}
